import React from 'react'

export default () => (
  <svg
    width="auto"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_5410_9742)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.502 11.6102L14.9102 13.686V16.1586V17.8346L18.502 15.7589V11.6102ZM8.3947 6.55089L11.9865 8.62662L15.5783 6.55089L11.9865 4.47517L8.3947 6.55089ZM5.47382 13.6831V15.7589L6.44746 16.3185L9.06566 17.8317V13.6831L5.47382 11.6102V13.686V13.6831ZM3.52658 16.8809V19.1308L2.55293 18.5683L1.57935 18.0059V11.9986V5.99128L11.9865 -0.0160522L22.3937 5.99128V18.0087L17.1886 21.0124L14.9074 22.3286V20.0787L20.4464 16.8809V8.23831L12.9601 12.5611C12.9601 13.7602 12.9601 14.9566 12.9601 16.1557V23.4535L11.9865 24.0161L11.0129 23.4535L6.78149 21.0124L5.47382 20.2586V18.0087L11.0129 21.2065V12.5639L3.52658 8.24115V16.8838V16.8809ZM11.9865 10.8736L4.50023 6.55089L11.9865 2.22814L19.4728 6.55089L11.9865 10.8736Z"
        fill="#151718"
      />
    </g>
    <defs>
      <clipPath id="clip0_5410_9742">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
